<script setup lang="ts">
import { useCurrencies } from "@/app/composables/useCurrencies"
import { onMounted, onUnmounted, ref, watch } from "vue"

const props = defineProps({
  name: String,
  value: String,
  icon: String,
  style: String,
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(["toggle"])

const { getIconByTicker } = useCurrencies()

const menuOpen = ref(props.isOpen)
const selectRef = ref<HTMLElement | null>(null)

watch(() => props.isOpen, (newVal) => {
  menuOpen.value = newVal
})

function toggleDropdown(e: MouseEvent) {
  e.stopPropagation()
  menuOpen.value = !menuOpen.value
  emit("toggle", menuOpen.value)
}

function handleKeydown(e: KeyboardEvent) {
  if (e.key === "Escape" && menuOpen.value) {
    menuOpen.value = false
    emit("toggle", false)
  }
}

onMounted(() => {
  document.addEventListener("keydown", handleKeydown)
})

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown)
})
</script>

<template>
  <div ref="selectRef" class="select" :data-testid="`transaction-${name}`" @click="toggleDropdown">
    <div class="select-item">
      <div class="select-value">
        <img v-if="icon" class="currency-icon" :src="getIconByTicker(icon)" alt="">
        <div data-testid="selectValue">
          {{ value }}
        </div>
      </div>
      <img
        :src="`/assets/images/${menuOpen ? 'up' : 'down'}-arrow.svg`"
        style="width: 12px"
        alt=""
      >
    </div>

    <div v-if="menuOpen" class="items" data-testid="selectItems">
      <slot name="header" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select {
  position: relative;
  height: 100%;
  cursor: pointer;
}

.select-value {
  display: flex;
  align-items: center;
  gap: 10px;
}

.currency-icon {
  width: 16px;
  height: 21px;
}
.select-item {
  display: flex;
  padding: 10px;
  border-radius: 5px;
  background: var(--be-small-card-bg);
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 100%;
}

.items {
  border-radius: 8px;
  background: var(--be-bg);
  padding: 8px;
  background: var(--be-small-card-bg);
  margin-top: 10px;
  width: 100%;
  position: absolute;
  z-index: 1;
}
.currency-balance:hover {
  opacity: 0.8;
  transition: all 0.3s ease;
}
</style>
